/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Leave Service API
 * Leave management microservice (multi-step approvals, delegation, holidays)
 * OpenAPI spec version: v1
 */

/**
 * Current status of the leave request
 */
export type LeaveRequestStatus =
  (typeof LeaveRequestStatus)[keyof typeof LeaveRequestStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LeaveRequestStatus = {
  DRAFT: "DRAFT",
  SUBMITTED: "SUBMITTED",
  LEVEL_1_RECOMMENDS: "LEVEL_1_RECOMMENDS",
  LEVEL_2_RECOMMENDS: "LEVEL_2_RECOMMENDS",
  HR_ACKNOWLEDGEMENT: "HR_ACKNOWLEDGEMENT",
  CEO_APPROVED: "CEO_APPROVED",
  REJECTED: "REJECTED",
  CANCELLED: "CANCELLED",
  HOD_RECOMMENDED: "HOD_RECOMMENDED",
  CEO_REJECTED: "CEO_REJECTED",
} as const;
